import { render, staticRenderFns } from "./ProductSelectSizeModal.vue?vue&type=template&id=0579ddca&scoped=true"
import script from "./ProductSelectSizeModal.vue?vue&type=script&lang=ts"
export * from "./ProductSelectSizeModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductSelectSizeModal.vue?vue&type=style&index=0&id=0579ddca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579ddca",
  null
  
)

export default component.exports